import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardHelpIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.09 9.13672C9.3251 8.46839 9.78915 7.90483 10.4 7.54585C11.0108 7.18688 11.7289 7.05566 12.4272 7.17543C13.1255 7.2952 13.7588 7.65824 14.2151 8.20025C14.6713 8.74225 14.9211 9.42824 14.92 10.1367C14.92 12.1367 11.92 13.1367 11.92 13.1367M12 17.1367H12.01M7.8 21.1367H16.2C17.8802 21.1367 18.7202 21.1367 19.362 20.8097C19.9265 20.5221 20.3854 20.0632 20.673 19.4987C21 18.857 21 18.0169 21 16.3367V7.93672C21 6.25656 21 5.41648 20.673 4.77475C20.3854 4.21026 19.9265 3.75132 19.362 3.4637C18.7202 3.13672 17.8802 3.13672 16.2 3.13672H7.8C6.11984 3.13672 5.27976 3.13672 4.63803 3.4637C4.07354 3.75132 3.6146 4.21026 3.32698 4.77475C3 5.41648 3 6.25656 3 7.93672V16.3367C3 18.0169 3 18.857 3.32698 19.4987C3.6146 20.0632 4.07354 20.5221 4.63803 20.8097C5.27976 21.1367 6.11984 21.1367 7.8 21.1367Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardHelpIcon;
